<div class="modal-header">
  <h2 class="modal-title">{{ title }}</h2>
  <button
    type="button"
    class="btn-close"
    (click)="closeModal()">
  </button>
</div>
<div class="modal-body">
  @if (imageUrl) {
    <img
      [src]="imageUrl"
      class="img-fluid"
      alt="Events Flyer">
  }
</div>